import React from "react";
import styles from "./RadioSelector.module.scss";

type TRadioSelectorItem = {
  title: string;
  value: string;
};

type TRadioSelectorItemOption = {
  option: TRadioSelectorItem;
  selectorID: string;
  selected: string;
  onSelect: (event: TRadioSelectorItem) => void;
};

type TRadioSelector = {
  options: TRadioSelectorItem[];
  selectorID: string;
  onSelect: (option: string) => void;
  selected: string;
};

const RadioSelector: React.FC<TRadioSelector> = ({
  options,
  selectorID,
  onSelect,
  selected,
}) => {
  const onClick = (option) => {
    onSelect(option.value);
  };

  return (
    <div className={styles.RadioSelector}>
      {options.map((option) => (
        <RadioSelectorItem
          option={option}
          selectorID={selectorID}
          selected={selected}
          onSelect={onClick}
          key={option.value}
        />
      ))}
    </div>
  );
};

const RadioSelectorItem: React.FC<TRadioSelectorItemOption> = ({
  option,
  selectorID,
  onSelect,
  selected,
}) => {
  const onClick = () => {
    onSelect(option);
  };

  return (
    <div onClick={onClick} className={styles.RadioSelectorItem}>
      <input
        onChange={onClick}
        type="radio"
        name={selectorID}
        value={option.value}
        defaultChecked={option.value === selected}
        id={`${selectorID}_${option.value}`}
      />
      <label htmlFor={`${selectorID}_${option.value}`}>{option.title}</label>
    </div>
  );
};
export default RadioSelector;
